module.exports = __webpack_public_path__ + "static/media/sort-down.c1f93273.svg";